
import { FaWhatsapp, FaTelegram, FaInstagram, FaComment } from 'react-icons/fa';
import Layout from '../../components/Layout';


const Contact = () => {
    return (
        <Layout>
            <div style={{ padding: '20px', textAlign: 'center' }}>
                <p className='text-white mt-5'>Ak máte akékoľvek otázky, kontaktujte nás cez nasledujúce platformy:</p>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px', marginTop: '30px' }}>
                    <a href="https://wa.me/421917782762" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#25D366', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <FaWhatsapp size={24} /> WhatsApp: +421 917 782 762
                    </a>
                    <a href="sms:+421917782762" style={{ textDecoration: 'none', color: '#007AFF', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <FaComment size={24} /> iMessage: +421 917 782 762
                    </a>
                    <a href="https://t.me/patodovi" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#0088cc', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <FaTelegram size={24} /> Telegram: @patodovi
                    </a>
                    <a href="https://instagram.com/arbitrage.sk" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#E4405F', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <FaInstagram size={24} /> Instagram: @arbitrage_sk
                    </a>

                </div>
            </div>
        </Layout>

    );
};

export default Contact;